<template>
  <div class="admin">
    <h1>POP admin page</h1>
    <div class="search">
        Search: <input v-on:keyup.enter = "search" type="text" v-model="searchTerm"><button @click="search">GO</button>
    </div>
    <div class="loading" :class="{active: loading}"><span>Loading</span></div>
    <ul class="status">
        <li @click="changeStatus(0)" :class="{active: status == 0}"><span>Pending</span></li>
        <li @click="changeStatus(1)" :class="{active: status == 1}"><span>Approved</span></li>
        <li @click="changeStatus(2)" :class="{active: status == 2}"><span>Rejected</span></li>
    </ul>
    <table>
        <thead>
            <tr>
                <th>id</th>
                <th>Deidicating to First Name</th>
                <th>Deidicating to Last Name</th>
                <th>Message</th>
                <th>Note Type</th>
                <th>Your First Name</th>
                <th>Your Last Name</th>
                <th>Email</th>
                <th>Image</th>
                <th>Date</th>
                <th>Approved</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(submission, index) in submissions[status].submissions">
                <td>{{submission.id}}</td>
                <td>{{submission.firstName}}</td>
                <td>{{submission.lastName}}</td>
                <td>{{submission.preText}}</td>
                <td>{{submission.noteType}}</td>
                <td>{{submission.yourFirstName}}</td>
                <td>{{submission.yourLastName}}</td>
                <td>{{submission.email}}</td>
                <td><img v-if="submission.uploadedImageFile != ''" :src="'https://app.brighton.com/power-of-pink/tmp/'+submission.uploadedImageFile" alt=""/></td>
                <td>{{submission.insertedDate}}</td>
                <td>
                    <select v-model="submission.approved">
                        <option value='0'>PENDING</option>
                        <option value='1'>APPROVE</option>
                        <option value='2'>REJECT</option>
                    </select>
                </td>
            </tr>
        </tbody>
    </table>
    <button @click="update">Update</button>
    <div class="pagination">
        <span>Page:</span> 
        <select @change="changePage">
            <option :value="n" v-for="n in Math.ceil(parseInt(submissions[status].totalRecords) / numPerPage)">{{n}}</option>
        </select>
    </div>
  </div>
</template>


<script>
    
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
const axios = require('axios');
export default {
    name: 'home',
    components: {
    // HelloWorld
    },
    data () {
        return {
            loading: false,
            error: '',
            numPerPage: 20,
            status: 0,
            searchTerm: '',
            submissions: [
                //pending
                {
                    submissions: [],
                    totalRecords: 0,
                    pageNum: 1
                },
                // approved
                {
                    submissions: [],
                    totalRecords: 0,
                    pageNum: 1
                },
                // rejectedSubmissions: {
                {
                    submissions: [],
                    totalRecords: 0,
                    pageNum: 1
                }
            ]
            // lastSubmissionID: -1,

        }
    },
    mounted () {
        this.loadSubmissions((data)=>{
          
        })
    },
    methods: {
        search(){
            this.loadSubmissions((data)=>{})

        },
        // changePage1(e){
        //     console.log(e.target.value)
        // },
        changePage(e) {
            this.submissions[this.status].pageNum = e.target.value
            this.loadSubmissions((data)=>{})
        },
        changeStatus(status) {
            // this.searchTerm = ''
            this.status = status
            // this.searchTerm = 
            this.loadSubmissions((data)=>{
                
            })
        },
        async update() {
            this.loading = true
            var formData = new FormData();
            formData.append('dev', process.env.NODE_ENV)
            formData.append('approved', this.status)
            formData.append('submissions', JSON.stringify(this.submissions[this.status].submissions))
            let url = `https://app.brighton.com/power-of-pink/api/admin/update`
            this.loading = true
            let returnedData = await axios( 
            {
                method: 'POST',
                url: url,
                responseType: 'json',
                data: formData,
                config: { headers: {'Content-Type':  'application/x-www-form-urlencoded'}},
            })
            this.loading = false
            if(returnedData.data.success) {
               this.loadSubmissions(()=>{})
            }
            else
                this.error = returnedData.data
        },
        async loadSubmissions(callBack) {
            var formData = new FormData();
            formData.append('dev', process.env.NODE_ENV)
            formData.append('approved', this.status)
            formData.append('page', this.submissions[this.status].pageNum)
            formData.append('numPerPage', this.numPerPage)
            formData.append('searchTerm', this.searchTerm)
            let url = `https://app.brighton.com/power-of-pink/api/admin`
            this.loading = true
            let returnedData = await axios( 
            {
                method: 'POST',
                url: url,
                responseType: 'json',
                data: formData,
                config: { headers: {'Content-Type':  'application/x-www-form-urlencoded'}},
                // onUploadProgress: function (e) {
                //     if (e.lengthComputable) {
                //         console.log("e.loaded: %o, e.total: %o, percent: %o", e.loaded, e.total, (e.loaded / e.total ) * 100);
                //     }
                // },
            })
            this.loading = false
            if(returnedData.data.success) {
                // this.lastSubmissionID = returnedData.data.pendingSubmissions[returnedData.data.pendingSubmissions.length -1].id
                this.submissions[this.status].submissions = returnedData.data.submissions
                this.submissions[this.status].totalRecords = returnedData.data.totalRecords 
                if(this.submissions[this.status].pageNum > this.submissions[this.status].totalRecords / this.numPerPage ) 
                this.submissions[this.status].pageNum = Math.ceil(this.submissions[this.status].totalRecords / this.numPerPage)
                if(this.submissions[this.status].pageNum == 0)
                this.submissions[this.status].pageNum = 1
                callBack(returnedData.data)
            }
            else
                this.error = returnedData.data
        }
        
    }
}

</script>
<style scoped lang="scss">
    .admin{
        .loading.active{
            display:block;
        }
        .loading{
            display: none;
            text-align: center;
            position: fixed;
            height: 100%;
            width: 100%;
            background: rgba(255,255,255,0.6);
            span{
                text-align:center;
                display:inline-block;
                color:red;
                text-align:center;
                border:1px solid red;
                padding:5px;
                margin:10px auto;
                font-size:20px;
                margin-top:20%;
            }
        }
        h1{
            text-align:center;
        }
        text-align:right;
        display:block;
        .status{
            list-style-type: none;
            display:block;
            text-align:left;
            margin:0;
            padding:0;
            li{
                background-color: #ccc;
                display:inline-block;
                padding:10px;
                vertical-align: middle;
                color:#fff;
                font-weight:bold;
                cursor: pointer;
                /* border:1px solid #ebebeb; */
                span{
                    display:block;
                }
            }
            li.active,
            li:hover {
                background:#999;
                color:#000;
            }
        }
        button{
            margin-top:20px;
            cursor: pointer;
            border: 0;
            outline: 0;
            color: #fff;
            padding: 0 10px;
            text-align: center;
            background: #eb76b8;
            vertical-align: top;
            display: inline-block;
            text-transform: uppercase;
            font: 16px/32px 'Lato', Arial, Helvetica, sans-serif;
        }
        table{
            text-align:left;
            border-collapse: collapse;
            border:1px solid #ccc;
            thead{
                tr{
                    th{
                        border:1px solid #ccc;
                        padding: 10px;
                        box-sizing:Border-box;
                    }
                }
            }
            tbody{
                tr:nth-child(even),
                tr:hover{
                    background-color:#ebebeb;
                }
                tr{
                    td{
                        border:1px solid #ccc;
                        padding: 10px;
                        box-sizing:Border-box;
                        img{
                            width:200px;

                        }
                    }
                }
            }
        }
        .search{
            display:block;
            input,
            button{
                display:inline-block;
                vertical-align:middle;
                margin: 0;
                padding:0 5px;
                height:35px;
                box-sizing: border-box;
            }
        }
        .pagination{
            display:block;
            margin:10px auto;
            text-align:center;
            font-weight:bold;
            select{
                height: auto;
                display: inline-block;
                margin: 0 auto;
                padding: 10px;
                width: auto;
            }
            span{
                padding:10px;
            }
            /* span:hover, */
            /* span.active {
                background:black;
                color:white;
            }
            span{
                border:1px solid #ccc;
                cursor: pointer;
                display:inline-block;
                padding:10px;
                margin:0 10px;
            } */
        }
    }
</style>